import React, { useState } from 'react';
import Sidebar from '../sidebarpage/sidebar'; // Asegúrate de que la ruta sea correcta
import { Outlet } from 'react-router-dom'; // Para renderizar rutas secundarias
import { FaBars } from 'react-icons/fa';
import './principal.css'; // Archivo CSS para los estilos

const Principal = () => {
    // En móvil arranca cerrado (el menú es overlay); en escritorio, abierto.
    const esMovil = () => typeof window !== 'undefined' && window.innerWidth <= 768;
    const [isOpen, setIsOpen] = useState(() => !esMovil());

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const [selectedOption, setSelectedOption] = useState('Lead Dragon');
    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        // Al navegar en móvil, cerrar el menú overlay.
        if (esMovil()) setIsOpen(false);
    };

    const user = JSON.parse(sessionStorage.getItem('user') || 'null');
    const userName = user?.userName || user?.userEmail || 'Usuario';
    const initials = userName
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0])
        .join('')
        .toUpperCase();

    return (
        <div className="app-shell">
            {isOpen && <div className="sidebar-backdrop" onClick={toggleSidebar} aria-hidden="true" />}
            <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} onOptionSelect={handleOptionSelect} />
            <div className={`app-main ${isOpen ? 'with-sidebar' : 'full'}`}>
                <header className="app-topbar">
                    <div className="app-topbar__left">
                        {!isOpen && (
                            <button onClick={toggleSidebar} className="app-topbar__toggle" aria-label="Abrir menú">
                                <FaBars />
                            </button>
                        )}
                        <h1 className="app-topbar__title">{selectedOption}</h1>
                    </div>
                    <div className="app-topbar__user">
                        <div className="app-topbar__avatar">{initials}</div>
                        <span className="app-topbar__name">{userName}</span>
                    </div>
                </header>
                <main className="app-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Principal;
